import { getToken, getUser } from "../../Utils/Common"
import Moment from "moment"
import { getAPICall } from "../axiosMethodCalls"

export const searchPayablesAgingReport = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "reports/get_payables_aging",
      {
        requester: getUser(),
        token: getToken(),
        expense_type: data.expense_id,
        supplier_id: data.supplier_id,
        date_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : "",
        date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
        page: data.page,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const searchExpenseByType = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "reports/get_expense_breakdown",
      {
        requester: getUser(),
        token: getToken(),
        date_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        date_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        // expense_type_id: data.expense_type_id,
        expense_type: data.expense_type,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const searchExpenseByDate = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "reports/get_expense_by_date",
      {
        requester: getUser(),
        token: getToken(),
        date_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        date_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const getExpenseByDateReport = async (filter) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "reports/get_expense_breakdown_by_day",
      {
        requester: getUser(),
        token: getToken(),
        date_from: Moment(filter.date_from).format("YYYY-MM-DD"),
        date_to: Moment(filter.date_to).format("YYYY-MM-DD"),
        expense_type_id: filter.expense_type_id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const searchExpenseReport = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "reports/expense_type_breakdown",
      {
        requester: getUser(),
        token: getToken(),
        expense_type:
          data.expense_type_value.label === "All"
            ? ""
            : data.expense_type_value.label,
        doc_type: data.doc_type_value.value,
        page: data.page,
        // particular_id: data.particular_id,
        // payment_status: data.payment_status,
        date_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        date_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}
